var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.props.message))])}
var staticRenderFns = []

export { render, staticRenderFns }